'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const EventCalendarStyledContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") EventCalendarStyledContext.displayName = "EventCalendarStyledContext";
export function useEventCalendarStyledContext() {
  const value = React.useContext(EventCalendarStyledContext);
  if (!value) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: useEventCalendarStyledContext must be used within an EventCalendarStyledContext.Provider. ' + 'The component requires access to calendar styling and locale information. ' + 'Ensure the component is rendered inside an EventCalendar component.' : _formatErrorMessage(205));
  }
  return value;
}